import { IOperation } from './i-operation';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ProjectModel } from '@project/model/project.model';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { BaseArticlesSequenceOperation } from './base-articles-sequence-operation';
import { ArrayUtils } from '../../util/array-utils';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { WireBridgeService } from '@project/components/article/manager/wire-bridge.service';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { LabelEditorStateManager } from '@project/components/label/label-editor/service/label-editor-state.manager';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';

export class UndoAttachUnusedLabelingArticlesOperation extends BaseArticlesSequenceOperation implements IOperation {
  private _oldSelection: any[];
  private _newSelection: any[];
  private _shouldUpdateDirectPrintingTableProvider: boolean;
  private _labelEditorStateManager: LabelEditorStateManager;

  constructor(
    articleContainers: ArticleContainer[],
    projectModel: ProjectModel,
    projectArticleService: ProjectArticleService,
    projectMetaElementService: ProjectMetaElementService,
    selectionModel: SelectionModel,
    selectionModelService: SelectionModelService,
    oldSelection: any[],
    shouldUpdateDirectPrintingTableProvider: boolean,
    wireBridgeService: WireBridgeService,
    articleContainerLoader: ArticleContainerLoader,
    articleContainerFactory: ArticleContainerFactory,
    containerService: ContainerService,
    applicationRefreshService: ApplicationRefreshService,
    detachArticleUsageService: DetachArticleUsageService,
    labelEditorStateManager: LabelEditorStateManager
  ) {
    super(
      articleContainers,
      projectModel,
      projectArticleService,
      projectMetaElementService,
      selectionModel,
      selectionModelService,
      wireBridgeService,
      articleContainerLoader,
      articleContainerFactory,
      containerService,
      applicationRefreshService,
      detachArticleUsageService
    );
    this._oldSelection = oldSelection;
    this._newSelection = selectionModel.selectedObjects.concat();
    this._shouldUpdateDirectPrintingTableProvider = shouldUpdateDirectPrintingTableProvider;
    this._labelEditorStateManager = labelEditorStateManager;
  }

  public getQualifiedClassName(): string {
    return 'UndoAttachUnusedLabelingArticlesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public async performRedo(): Promise<void> {
    const shouldRestoreSelection: boolean = !!this._newSelection && ArrayUtils.equals(this.selectionModel.selectedObjects, this._oldSelection);
    await this.attachArticles();
    if (shouldRestoreSelection) {
      this.updateSelection(this._newSelection);
    }
    this.dispatchCompleteMessage();
  }

  public async performUndo(): Promise<void> {
    const shouldRestoreSelection: boolean = !!this._oldSelection && ArrayUtils.equals(this.selectionModel.selectedObjects, this._newSelection);
    await this.detachArticles();
    if (shouldRestoreSelection) {
      this.updateSelection(this._oldSelection);
    }
    this.dispatchCompleteMessage();
  }

  private updateSelection(selections: any[]): void {
    selections.forEach(selection => {
      this.selectionModelService.selectObject(selection, true, false, true);
    });
  }

  private dispatchCompleteMessage(): void {
    if (this._shouldUpdateDirectPrintingTableProvider) {
      this._labelEditorStateManager.notifyUpdateDirectPrintingTableProvider();
    }
  }
}
